<template>
  <header class="page-header">
    <div class="page-header__languages">
      <div class="container">
        <LanguageSelector />
      </div>
    </div>

    <div class="page-header__content">
      <div class="container">
        <Logo />

        <button class="page-header__hamburger" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <Menu className="page-header__menu" @toggle="toggleMenu" :isFooter="false" />
      </div>
    </div>
  </header>
</template>

<script>
import Logo from "@/components/layout/Logo";
import Menu from "@/components/layout/Menu";
import LanguageSelector from "@/components/layout/LanguageSelector";

export default {
  name: "Header",
  components: { Logo, Menu, LanguageSelector },
  methods: {
    toggleMenu(event) {
      const { target } = event;

      if (!target.classList.contains("page-header__hamburger--open")) {
        target.classList.add("page-header__hamburger--open");
        document.querySelector(".page-header__menu").classList.add("page-header__menu--active");
        document.body.classList.add("menu-open");
      } else {
        target.classList.remove("page-header__hamburger--open");
        document.querySelector(".page-header__menu").classList.remove("page-header__menu--active");
        document.body.classList.remove("menu-open");
      }
    }
  }
};
</script>
